import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export class Team {
  container: String
  next: String
  prev: String

  constructor(container: String, next: String, prev: String) {
    ;(this.container = container), (this.next = next), (this.prev = prev), this.initSlider()
    this.showDescription()
  }

  initSlider() {
    new Swiper(this.container, {
      slidesPerView: 1,
      spaceBetween: 80,
      navigation: {
        prevEl: this.prev,
        nextEl: this.next,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1240: {
          slidesPerView: 4,
        },
      },
    })
  }

  showDescription() {
    const buttons = document.querySelectorAll('.team__button')

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const buttonBox = button.closest('.team__box')

        buttonBox?.classList.toggle('active')
      })
    })
  }
}
